import {
  Resume,
  Card,
  ResumeSkill,
  ResumeWorkExperience,
  ResumeEducation,
  ResumeLanguage,
  ResumeInternship,
  ResumeActivity,
  ResumeCourse,
  ResumeReference,
} from 'packages/types'

/**
 * NOTE: this helper is created for Resume Editor Field Tracking business logic,
 * it can not fit your requirements because of specific fields set
 */
export const isCardEmpty = <K extends keyof Resume>(card: Card | null, section: K): boolean => {
  if (!card) return true
  switch (section) {
    case 'skills':
      const resumeSkillCard = card as ResumeSkill
      return !resumeSkillCard.skill
    case 'workExperiences':
      const workExperienceCard = card as ResumeWorkExperience
      return !workExperienceCard.title
    case 'educations':
      const educationCard = card as ResumeEducation
      return !educationCard.school
    case 'languages':
      const languageCard = card as ResumeLanguage
      return !languageCard.language
    case 'internships':
      const internshipCard = card as ResumeInternship
      return !internshipCard.title
    case 'activities':
      const activityCard = card as ResumeActivity
      return !activityCard.title
    case 'courses':
      const courseCard = card as ResumeCourse
      return !courseCard.course
    case 'references':
      const referenceCard = card as ResumeReference
      return !referenceCard.name
    default:
      return true
  }
}
